import {
    ANALYTICS_CARD_ONBOARDING_APPROVED_CLICK_NOT_NOW,
    ANALYTICS_CARD_ONBOARDING_MVP_2_STEP_VIEWED,
    ANALYTICS_CARD_ONBOARDING_UPLOAD_DOCS_CLICK_SUBMIT,
    ANALYTICS_CARD_ONBOARDING_UPLOAD_DOCS_CLICK_UPLOAD,
    ANALYTICS_CARD_ONBOARDING_IN_REVIEW_CLICK_DASHBOARD_FOOTER,
} from '@perpay-web/fintech/constants/actionTypes';

export function analyticsPerpayCreditCardOnboardingApprovedClickNotNow() {
    return {
        type: ANALYTICS_CARD_ONBOARDING_APPROVED_CLICK_NOT_NOW,
    };
}

export function analyticsCardOnboardingUploadDocsClickSubmit() {
    return {
        type: ANALYTICS_CARD_ONBOARDING_UPLOAD_DOCS_CLICK_SUBMIT,
    };
}

export function analyticsCardOnboardingUploadDocsClickUploadAddress() {
    return {
        type: ANALYTICS_CARD_ONBOARDING_UPLOAD_DOCS_CLICK_UPLOAD,
        payload: { documentType: 'proof-of-address' },
    };
}

export function analyticsCardOnboardingUploadDocsClickUploadId() {
    return {
        type: ANALYTICS_CARD_ONBOARDING_UPLOAD_DOCS_CLICK_UPLOAD,
        payload: { documentType: 'proof-of-id' },
    };
}

export function analyticsCardOnboardingInReviewClickDashboardFooter() {
    return {
        type: ANALYTICS_CARD_ONBOARDING_IN_REVIEW_CLICK_DASHBOARD_FOOTER,
    };
}

export function analyticsPerpayCreditCardOnboardingReviewDirectDepositStepViewed(
    step,
    partner,
) {
    return {
        type: ANALYTICS_CARD_ONBOARDING_MVP_2_STEP_VIEWED,
        payload: { step, partner },
    };
}
